export const getMapserviceTileJson = (abortController?: AbortController) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/mapservices/5e8fdb7af299c21b43115570/tile-jsons`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};

export const getMapserviceStyles = (
  layerId: string,
  apikey?: string,
  abortController?: AbortController
) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/tile-jsons/datasets/${layerId}/styles`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${
          apikey ? apikey : localStorage.getItem("token")
        }`,
        "Content-Type": "application/json",
      },
      signal: abortController?.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};
